<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['field_name', 'department', 'com_name', 'rank', 'writer_name']"
      :options="[{}, { type: 'date', label: '계획일' }, { type: 'date', label: '작성일', value: 'date', readonly: true }, { type: 'alert', label: '알림 대상자 선택' },]"
    />

    <!--관리자 그룹-->
    <table-custom
      title="점검 담당자 그룹"
      :board="board"
      :is-print="isPrint"
      :tableData="[
        {
          id: 'target',
          title: '점검대상',
          type: 'select',
          selectData: [
            '건설공사 기간 연장',
            '도급전 정보 제공',
            '반기별 점검',
            '보건교육',
            '비상대피 교육',
            '비상대피 자체평가',
            '비상대피 훈련',
            '비상연락/지원 체계도',
            '비상연락망',
            '비상조치계획 수립',
            '사업장 경영방침',
            '산업재해조사',
            '설계변경 요청',
            '수급인 산재예방 평가',
            '순회점검',
            '시정 및 예방조치',
            '아차사고',
            '안전교육',
            '안전보건관리 수행평가',
            '안전보건 예산',
            '안전보건 확보 의무',
            '안전보건대장 작성',
            '안전보건협의체 구성',
            '위험성평가',
            '유해위험요인 파악',
            '작업계획서',
            '작업중지제',
            '작업허가서',
            '장비점검',
            '재발방지계획서',
            '중대재해 발생 조사',
            '기타',
          ],
        },
        { id: 'group', title: '소속명(부서명)/직급', type: 'text' },
        { id: 'type', title: '직책', type: 'select', selectData: ['안전보건총괄책임자', '안전보건책임자', '안전보건조정자', '관리감독자', '안전관리자', '보건관리자', '산업보건의', '현장관리자', '안전담당자', '보건담당자', '담당자'] },
        { id: 'name', title: '성명', type: 'text' },
        { id: 'phone', title: '연락처', type: 'text' },
        { id: 'note', title: '점검방법', type: 'textarea' },
        { id: 'cycle', title: '점검주기', type: 'text' },
      ]"
      :mobile="['target', 'group']"
      v-model="form.group1"
      class="mt-28px"
    />

    <!--파일첨부-->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-28px" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import TableCustom from "@/components/TableCustom.vue";
import VueCookie from "vue-cookie";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.stdInfo) {
          value.stdInfo.계획일 = value.stdInfo.계획일 || this.date;
        }
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        group1: [],
        fileList: [],
      },
      date: "",
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  created() {
    this.date = VueCookie.get("list137_selectday");
    VueCookie.delete("list137_selectday");
    this.initBreadcrumb();
  },
  methods: {
    initBreadcrumb() {
      if (this.projectId === 5) {
        this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "안전보건 점검 계획" }, { title: "시설물 안전점검 계획", active: true }]);
      }
    },
  },
};
</script>

<style scoped></style>
